import React from 'react';
import FormTextContainer from '../../../redux/containers/FormTextContainer';

const ModemDeliveryAddress = () =>
  <div className="container">
    <div className="row">
      <div className="col-sm-6 col-md-4">
        <FormTextContainer
          name="modemName"
          label="Name"
          placeholder="Name"
          autotestClass="autotest-modem-name"
          maxLength={40}
          required
        />
      </div>
      <div className="col-sm-6 col-md-4">
        <FormTextContainer
          name="modemCompany"
          label="Company"
          placeholder="Company"
          autotestClass="autotest-modem-company"
          maxLength={100}
        />
      </div>
    </div>
    <div className="row">
      <div className="col-sm-6 col-md-4">
        <FormTextContainer
          name="modemAddress"
          label="Address"
          placeholder="Address"
          autotestClass="autotest-modem-delivery1"
          maxLength={100}
          required
        />
      </div>
      <div className="col-sm-6 col-md-4">
        <FormTextContainer
          name="modemSuburb"
          label="Suburb"
          placeholder="Suburb"
          autotestClass="autotest-modem-delivery2"
          maxLength={100}
          required
        />
      </div>
    </div>
    <div className="row">
      <div className="col-sm-6 col-md-4">
        <FormTextContainer
          name="modemCity"
          label="City"
          placeholder="City"
          autotestClass="autotest-modem-delivery3"
          maxLength={100}
          required
        />
      </div>
      <div className="col-sm-6 col-md-4">
        <FormTextContainer
          name="modemPostcode"
          label="Postcode"
          placeholder="Postcode"
          autotestClass="autotest-modem-postcode"
          maxLength={10}
          required
        />
      </div>
    </div>
  </div>
;

export default ModemDeliveryAddress;



/** WEBPACK FOOTER **
 ** ./src/components/checkout/ModemDeliveryAddress/ModemDeliveryAddress.js
 **/